import { StateModel } from '../../shared/models/default-state.model';
import {
  IMPORT_RECRUITER_REQUEST,
  IMPORT_RECRUITER_REQUEST_ERROR,
  IMPORT_RECRUITER_REQUEST_SUCCESS,
  IMPORT_RECRUITER_CLEAR_ERROR,
} from '../actions/recruiter-import.action';

const INITIAL_STATE: StateModel = {
  loading: false,
  loaded: false,
  error: null,
  data: [],
};

export const recruiterImportDatasetReducer = (state: StateModel = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case IMPORT_RECRUITER_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };

    case IMPORT_RECRUITER_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
        error: null,
      };

    case IMPORT_RECRUITER_REQUEST_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };

    case IMPORT_RECRUITER_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default recruiterImportDatasetReducer;
